export default {
  drawerTitle: {
    id: 'bo_seller.listings.deals.info.drawer.title',
    defaultMessage: 'How it works',
  },
  howItWorks: {
    id: 'bo_seller.listings.deals.info.drawer.how_does_it_work.title',
    defaultMessage: 'How does it work?',
  },
  howItWorksContent1: {
    id: 'bo_seller.listings.deals.info.drawer.how_does_it_work.content_1',
    defaultMessage:
      'This limited-time deal applies to selected products in selected markets. Pay a reduced commission rate when you list these products at or below the recommended prices during the deal period. When the deal ends, your commission rate will return to the pre-deal rate.',
  },
  howItWorksContent2: {
    id: 'bo_seller.listings.deals.info.drawer.how_does_it_work.content_2',
    defaultMessage:
      "We may update recommended prices during deal periods to keep up with market competition. You'll receive advanced notice of price changes via CSV.",
  },
  tips: {
    id: 'bo_seller.listings.deals.info.drawer.tips.title',
    defaultMessage: 'Tips for taking advantage of this deal',
  },
  tipsContent1: {
    id: 'bo_seller.listings.deals.info.drawer.tips.content_1',
    defaultMessage: 'Maintain your inventory of selected products',
  },
  tipsContent2: {
    id: 'bo_seller.listings.deals.info.drawer.tips.content_2',
    defaultMessage:
      'Keep your listing prices at or below the recommended prices',
  },
  tipsContent3: {
    id: 'bo_seller.listings.deals.info.drawer.tips.content_3',
    defaultMessage: 'Win BackBoxes to get your products in front of customers',
  },
  whyTakeAdvantage: {
    id: 'bo_seller.listings.deals.info.drawer.why_take_advantage.title',
    defaultMessage: 'Why take advantage of the deal?',
  },
  whyTakeAdvatageContent1: {
    id: 'bo_seller.listings.deals.info.drawer.why_take_advantage.content_1',
    defaultMessage: 'Reduce your commission rates to increase margins',
  },
  whyTakeAdvatageContent2: {
    id: 'bo_seller.listings.deals.info.drawer.why_take_advantage.content_2',
    defaultMessage: 'Move inventory faster',
  },
  whyTakeAdvatageContent3: {
    id: 'bo_seller.listings.deals.info.drawer.why_take_advantage.content_3',
    defaultMessage: 'Get your products in front of more customers',
  },
}
